import { ReportingBucketLatency } from '@eluve/api-contract';

/** Compact duration for latency cells/tiles: 42s · 3m 5s · 2h 14m. */
export const formatSeconds = (seconds: number | null | undefined): string => {
  if (seconds == null) {
    return '—';
  }
  const total = Math.round(seconds);
  if (total < 60) {
    return `${total}s`;
  }
  const minutes = Math.floor(total / 60);
  if (minutes < 60) {
    return `${minutes}m ${total % 60}s`;
  }
  return `${Math.floor(minutes / 60)}h ${minutes % 60}m`;
};

const percentileLine = (stats: ReportingBucketLatency['noteWait']): string =>
  `p50 ${formatSeconds(stats.p50)} · p90 ${formatSeconds(stats.p90)} · p95 ${formatSeconds(stats.p95)} · p99 ${formatSeconds(stats.p99)} · p100 ${formatSeconds(stats.p100)}`;

/** Hover text: full percentile ladders + where the note wait went. */
export const latencyBreakdownTitle = (
  latency: ReportingBucketLatency,
): string =>
  [
    `Note wait (${latency.noteWait.n} appts) — ${percentileLine(latency.noteWait)}`,
    `Upload delay (${latency.uploadDelay.n} appts) — ${percentileLine(latency.uploadDelay)}`,
    `Avg wait — upload ${formatSeconds(latency.avgWaitUpload)} · transcription ${formatSeconds(latency.avgWaitTranscription)} · generation ${formatSeconds(latency.avgWaitGeneration)}`,
  ].join('\n');
